import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid
} from '@mui/material';
import dayjs from 'dayjs';
import { scheduleAppointment } from '../../../services/appointments';
import { getPanelRole } from '../../../services/api';

const ScheduleConsultationDialog = ({ open, onClose, patient }) => {
    const [dateTime, setDateTime] = useState(dayjs().format('YYYY-MM-DDTHH:mm'));
    const [description, setDescription] = useState('');
    const roleUUID = getPanelRole();

    const handleSchedule = async () => {
        try {
            await scheduleAppointment({
                patient: patient.role_uuid,
                doctor: roleUUID,
                ts: dateTime,
                summary: description
            });

            onClose();
        } catch (err) {
            console.error('Erro ao agendar consulta', err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Agendar Consulta</DialogTitle>

            <DialogContent>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Data e Hora"
                            value={dateTime}
                            onChange={(e) => setDateTime(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            label="Descrição da consulta"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Cancelar
                </Button>

                <Button variant="contained" onClick={handleSchedule} disabled={!dateTime}>
                    Agendar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ScheduleConsultationDialog;
